import axios from 'axios'
import { getAuthHeader } from './config'
import { API_URL, HR_API_URL } from '../constants/api'

const baseURL = API_URL + '/users'
export const AUTH_KEY = 'hogartms-user'

const register = async (credentials) =>{
  const response = await axios.post(`${baseURL}/register` ,credentials ) ;
  return response.data 
}

const loginx = async (credentials) => {
  const response = await axios.post(`${baseURL}/login`, credentials)
  return response.data
}

const login = async (credentials) => {
  const response = await axios.post(`${HR_API_URL}/login`, credentials)
  return response.data
}

const logout = async () => {
  await axios.post(`${baseURL}/logout`, undefined, getAuthHeader())
}

export const fetchHrApi = async (endpoint, data) => {
  // console.log(endpoint, data,'endpoint, dataendpoint, dataendpoint, dataendpoint, data')
  try {
      const resp = await fetch(`${HR_API_URL}${endpoint}`)
      return resp.json()
  } catch (error) {
    return error
  }
}

export const fetchAuthenticatedHrData = async (endpoint) => {
    try {
        // console.log(authHeader())
        const token = JSON.parse(localStorage.getItem(AUTH_KEY)).token
        const resp = await fetch(`${HR_API_URL}${endpoint}`,{
            method: "GET",
            headers: {
                'Content-Type': "application/json",
                'Authorization': `Bearer ${token}`
                // ...authHeader
            }
        });
        return resp.json()
    } catch (error) {
        return error
    }
}

const update = async (user) => {
  const response = await axios.patch(
    `${baseURL}/me`,
    {
      name: user.name,
      email: user.email,
      mobile: user.mobile,
      username: user.username,
      photo: user.photo
    },
    getAuthHeader()
  )
  return response.data
}

const usersService = { register, login, logout, update }
export default usersService
